import { Button, Col, Row, Container } from "react-bootstrap";
import "./Homepage.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="homepage-new">
        <Container fluid className="hero-container">
          <div className="hero-content-wrapper">
            {/* Centered Hero Section */}
            <motion.div
              className="hero-main-content"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="hero-badge">
                <span>Innovation Meets Excellence</span>
              </div>

              <motion.h1
                className="hero-title"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.8 }}
              >
                Engineering Digital Products for the Next
                <span className="gradient-text hero-title">Billion-User</span>
              </motion.h1>

              <motion.p
                className="hero-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.8 }}
              >
                We build powerful digital products used by thousands worldwide.
                From mobile apps to scalable platforms, we create technology
                people love.
              </motion.p>

              <motion.div
                className="hero-actions"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, duration: 0.8 }}
              >
                <Button
                  className="btn-primary-hero"
                  onClick={() => navigate("/contact")}
                >
                  Join the Journey
                </Button>
                <Button
                  className="btn-secondary-hero"
                  onClick={() => navigate("/services")}
                >
                  Discover Our Products
                </Button>
              </motion.div>
            </motion.div>

            {/* Stats Section */}
            <motion.div
              className="hero-stats"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1, duration: 0.8 }}
            >
              <Row className="stats-row ">
                <Col md={4} className="stat-item">
                  <div className="stat-number">100+</div>
                  <div className="stat-label">Products Published</div>
                </Col>
                {/* <Col md={4} className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Happy Clients</div>
                </Col> */}
                <Col md={4} className="stat-item">
                  <div className="stat-number">5+</div>
                  <div className="stat-label">Years Experience</div>
                </Col>
              </Row>
            </motion.div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default HomePage;
